angular.module('dealerware.web.data').factory('DealerwareIssueModel', function ($http,Model,$q) {

    var model = new Model({
        baseEndpoint: '/locations/:location_id/cars/:vehicle_id/issues',
        customActions: {
            create: {
                method: 'POST',
                ignoreAssociations: true
            },
            delete: {
                method: 'PUT',
                endpoint: '/locations/:location_id/cars/:vehicle_id/issues/:id',
                ignoreAssociations: true
            },
            loadIssueImages: {
                method: 'GET',
                endpoint: '/locations/:location_id/cars/:vehicle_id/issues/:id/images',
                ignoreAssociations: true
            }
        }
    });

    jQuery.extend(model.prototype, {});

    return model;
});
